const CHANNELS = [
  {
    icon: "ri-star-line",
    name: "娱乐·综艺",
    desc: "综艺名场面、直播突发与舞台幕后第一线围观",
    hot: "今日 6 条冲榜",
    img: "https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20performer%20seen%20from%20behind%20on%20a%20glowing%20stage%20bathed%20in%20warm%20amber%20and%20crimson%20spotlights%2C%20crowd%20hands%20raised%20in%20foreground%2C%20editorial%20magazine%20cover%20photography%2C%20cinematic%20warm%20lighting%2C%20vivid%20orange%20accents%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=720&height=480&seq=channel-ent-58&orientation=landscape",
  },
  {
    icon: "ri-global-line",
    name: "民生·社会",
    desc: "街巷故事与公共话题，看普通人的高光与争议",
    hot: "今日 9 条讨论",
    img: "https://readdy.ai/api/search-image?query=People%20standing%20on%20a%20busy%20city%20street%20holding%20phones%20and%20talking%20to%20each%20other%2C%20warm%20evening%20street%20lamp%20light%20and%20shop%20glow%2C%20documentary%20editorial%20photography%2C%20warm%20cinematic%20tones%2C%20candid%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=720&height=480&seq=channel-life-58&orientation=landscape",
  },
  {
    icon: "ri-line-chart-line",
    name: "商业·财经",
    desc: "品牌舆情、资本动向与商业圈的高光与翻车现场",
    hot: "今日 4 件大事",
    img: "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20dusk%20with%20warm%20orange%20windows%20glowing%2C%20reflective%20glass%20towers%2C%20abstract%20graph%20lines%20overlay%2C%20editorial%20finance%20magazine%20cover%20photography%2C%20cinematic%20warm%20lighting%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=720&height=480&seq=channel-biz-58&orientation=landscape",
  },
  {
    icon: "ri-cpu-line",
    name: "科技·互联网",
    desc: "产品争议、算法之争与行业口水的吃瓜前线",
    hot: "今日 3 个瓜",
    img: "https://readdy.ai/api/search-image?query=Close%20up%20of%20smartphones%20and%20futuristic%20screens%20glowing%20on%20a%20table%20in%20a%20dark%20room%2C%20warm%20orange%20and%20blue%20minimal%20neon%20glow%2C%20tech%20editorial%20magazine%20photography%2C%20dramatic%20warm%20lighting%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=720&height=480&seq=channel-tech-58&orientation=landscape",
  },
];

export default function Channels() {
  return (
    <section id="channels" className="border-t border-background-200/70 bg-background-50 py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between flex-wrap gap-3 mb-5 md:mb-6">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold tracking-widest text-primary-600 uppercase">
              <i className="ri-apps-2-line" aria-hidden="true"></i> 专区入口
            </p>
            <h2 className="font-display font-black text-foreground-950 text-2xl md:text-3xl mt-2">今日围观专区</h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">按题材进瓜田，同一时间线里不同圈层各有各的热度，挑一条你感兴趣的深入围观。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {CHANNELS.map((c) => (
            <a
              key={c.name}
              href="#discuss"
              className="group overflow-hidden rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative h-36 md:h-40 overflow-hidden">
                <img
                  src={c.img}
                  alt={`${c.name}专区封面`}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
                <span className="absolute top-3 left-3 w-8 h-8 rounded-lg bg-background-50/90 text-primary-600 flex items-center justify-center">
                  <i className={c.icon} aria-hidden="true"></i>
                </span>
                <span className="absolute bottom-2 right-3 text-[11px] text-background-50/90">{c.hot}</span>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-foreground-950 group-hover:text-primary-700 transition-colors flex items-center justify-between">
                  {c.name}
                  <i className="ri-arrow-right-line opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" aria-hidden="true"></i>
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed mt-2 line-clamp-2">{c.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}